import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingVsFull3 = props => (
    <section id="outsourcing-vs-full-section3" className="my pt-5 blues-bg">
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingVsFull:section-3.title')}</h2>
            <p className='m-0'><Trans i18nKey="services:outsourcingVsFull:section-3.text" components={{ bold: <strong /> }} /></p>
        </Container>
    </section>
);

export default OutsourcingVsFull3;
